// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-items: flex-start;
  display: flex;
  line-height: var(--heading-line-height);
}

.summary {
  color: var(--summary-color);
  display: block;
  flex: 1;
  font-family: var(--heading-font-family);
  font-size: var(--heading-font-size);
  line-height: inherit;
}

.summary-aside {
  display: flex;
  gap: var(--space-1);
  height: 1lh;
}

.content {
  display: block;
  flex-grow: 1;
  margin-top: var(--content-header-gap, var(--space-3));
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/section/section.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,OAAO;EACP,uCAAuC;EACvC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qDAAqD;AACvD","sourcesContent":[".header {\n  align-items: flex-start;\n  display: flex;\n  line-height: var(--heading-line-height);\n}\n\n.summary {\n  color: var(--summary-color);\n  display: block;\n  flex: 1;\n  font-family: var(--heading-font-family);\n  font-size: var(--heading-font-size);\n  line-height: inherit;\n}\n\n.summary-aside {\n  display: flex;\n  gap: var(--space-1);\n  height: 1lh;\n}\n\n.content {\n  display: block;\n  flex-grow: 1;\n  margin-top: var(--content-header-gap, var(--space-3));\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
